<template lang="pug">
.home
	img.fundo(src="../assets/images/ticker-tape-one.jpg" style="filter: contrast(30%)")
	.hero-text
		h1 Radio Patrols
		h2 Ten-Four: One Eighty Seven
		h3 No Hard Chords on the Car Radio
		a.btn.btn-secondary.btn-lg.mt-3(href='/') Samuel Morse
</template>	

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		HelloWorld
	}
}
</script>

<style>

@import "../assets/stylings/engines.css";

body, html {
	height: 100%;
	width: 100%;
}

.fundo {
	background-image: url("../assets/images/titannic.jpg") no-repeat center center fixed;
	min-height: 100%;
	min-width: 100%;
	width: 100;
	height: auto;
	position: relative;
	background-size: cover;
	top: 0;
	left: 0;
	filter: contrast(60%);
	background-color: #607d8b;
	background-blend-mode: multiply;
}

</style>